import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../../apiConfig";
import Navbar from "../../components/navbar/Navbar";
import RightBar from "../../components/rightBar/RightBar";
import AboutContentOne from "./AboutContentOne";
import AboutContentTwo from "./AboutContentTwo";
import ContactComponent from "../../components/contactComponent/contactComponent";
import "./AboutStyles.scss";
import AboutContentThree from "./AboutContentThree";
import AboutContentFour from "./AboutContentFour";
import AboutContentFive from "./AboutContentFive";
import AboutContentSix from "./AboutContentSix";
import AboutContentSeven from "./AboutContentSeven";
import Modal from "../../components/modal/modal";
import ContactModal from "../../components/modal/contactModal/contactModal";
import Footer from "../../components/footer/footer";
const About = () => {
  const [modal, setModal] = useState(false);
  const [contactModal, setContactModal] = useState(false);
  const [certificatePath, setCertificatePath] = useState(null);
  const [companyProfilePath, setCompanyProfilePath] = useState(null);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/other-settings`);
        setCertificatePath(response.data.iso_certificate_path || null);
        setCompanyProfilePath(response.data.company_profile_pdf_path || null);
      } catch (error) {
        setCertificatePath(null);
        setCompanyProfilePath(null);
      }
    };

    fetchCertificate();
  }, []);

  return (
    <div className="About">
      <Navbar />
      <div className="about-background" id="about-background">
        <AboutContentOne setContactModal={setContactModal} />
      </div>
      <div className="about-bottom-container">
        <div className="left-about-container">
          <AboutContentTwo companyProfilePath={companyProfilePath} />
          <AboutContentThree />
          <AboutContentFour setModal={setModal} certificatePath={certificatePath} />
          <AboutContentFive />
          <AboutContentSix />
          <AboutContentSeven />
          <Footer />
        </div>

        <div className="about-right-bar">
          <RightBar />
        </div>
      </div>
      {modal ? <Modal setModal={setModal} certificatePath={certificatePath} /> : ""}
      {contactModal ? <ContactModal setContactModal={setContactModal} /> : ""}
    </div>
  );
};
export default About;
